import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";

import BackButton from "components/BackButton";
import ErrorMessage from "components/ErrorMessage";

import CTextField from "uis/CTextField";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0
  },
  main: {
    width: 500,
    margin: "70px auto 20px"
  },
  errorMessages: {
    marginBottom: 10
  },
  btnWrapper: {
    display: "block",
    marginTop: 50,
    textAlign: "center"
  }
});

class PasswordUpdate extends React.Component {
  componentWillUnmount() {
    this.props.init();
  }

  render() {
    const {
      classes,
      currentPassword,
      password,
      passwordConfirmation,
      errors
    } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>パスワード変更</h2>
          <BackButton />
        </div>

        <div className={classes.main}>
          <ErrorMessage messages={errors} className={classes.errorMessages} />

          <CTextField
            id="current-password"
            label="現在のパスワード"
            type="password"
            value={currentPassword}
            onChange={e =>
              this.props.changeForm("currentPassword", e.target.value)
            }
            margin="dense"
            fullWidth
          />
          <br />

          <CTextField
            id="password"
            label="新しいパスワード"
            type="password"
            value={password}
            onChange={e => this.props.changeForm("password", e.target.value)}
            margin="dense"
            fullWidth
          />
          <br />

          <CTextField
            id="password-confirmation"
            label="新しいパスワードの確認"
            type="password"
            value={passwordConfirmation}
            onChange={e =>
              this.props.changeForm("passwordConfirmation", e.target.value)
            }
            margin="dense"
            fullWidth
          />

          <div className={classes.btnWrapper}>
            <Button
              raised
              onClick={() =>
                this.props.handleSubmit(
                  currentPassword,
                  password,
                  passwordConfirmation
                )
              }
            >
              更新
            </Button>
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(PasswordUpdate);



// WEBPACK FOOTER //
// ./src/components/PasswordUpdate.jsx